<template lang="pug">
  div
    aside.main-menu.d-flex.flex-column.bg-black
      .pt-4.pb-2
        span.px-2.d-inline-block
          spend-hub-logo(ref='svgShLogo').size-48
        span(ref='svgShTextWrap')
          spend-hub-text.w-125
      .flex-1.pos-r.main-menu-items(:class='{ "is-collapsed": isMainMenuCollapsed }')
        simplebar(data-simplebar-auto-hide="true").pin.pin-xy.of-a
          el-menu(
            :default-active='activeMenuItem',
            :collapse='isMainMenuCollapsed',
            background-color='#000',
            text-color='#bbb',
            active-text-color='#fff',
            :unique-opened='true'
            @select='handleSelectMenu'
          ).d-flex.flex-column
            el-menu-item(index='/',
              :class='isMenuActive("/")'
              v-if='!isActiveCmp() && isCmdLockDown()'
            )
              font-awesome-icon(:icon='["fal", "desktop"]').el-icon-for-fa.fs-14
              span(slot='title') Dashboard

            el-menu-item(index='/sadmin-dashboard', :class='isMenuActive("sadmin-dashboard")' v-if='isActiveCmp()')
              font-awesome-icon(:icon='["fal", "desktop"]').el-icon-for-fa.fs-14
              span(slot='title') Dashboard

            el-menu-item(index='/companies', :class='isMenuActive("companies")' v-if='isActiveCmp()')
              font-awesome-icon(:icon='["fal", "industry"]').el-icon-for-fa.fs-14
              span(slot='title') Companies

            el-menu-item(index='/marqeta-transaction-list', :class='isMenuActive("marqeta-transaction-list")' v-if='isActiveCmp()')
              font-awesome-icon(:icon='["fal", "shopping-cart"]').el-icon-for-fa.fs-14
              span(slot='title') API Transactions
            
            

            //- el-menu-item(index='/companies', :class='isMenuActive("companies")' v-if='isActiveCmp()')
            //-   font-awesome-icon(:icon='["fal", "industry"]').el-icon-for-fa.fs-14
            //-   span(slot='title') Companies

            el-menu-item(
              index='/company-payment',
              :class='isMenuActive("company-payment")' v-if='isActiveCmp() && hasScreenAccess("company_ledger_screen_access")')
              font-awesome-icon(:icon='["fal", "industry"]').el-icon-for-fa.fs-14
              span(slot='title') Company Ledgers

            el-menu-item(index='/merchants', :class='isMenuActive("companies")' v-if='isActiveCmp()')
              font-awesome-icon(:icon='["fal", "users"]').el-icon-for-fa.fs-14
              span(slot='title') Merchants

            el-menu-item(
              index='/manual-payment',
              :class='isMenuActive("Manual Payment")'
              v-if='isActiveCmp() && hasScreenAccess("manual_payments_screen_access")'
            )
              font-awesome-icon(:icon='["fal", "users"]').el-icon-for-fa.fs-14
              span(slot='title') Manual Payment

            el-menu-item(
              index='/company-members',
              :class='isMenuActive("company-members")'
              v-if='isActiveCmp() && hasScreenAccess("company_members_screen_access")'
            )
              font-awesome-icon(:icon='["fal", "user-friends"]').el-icon-for-fa.fs-14
              span(slot='title') Company Members

            el-menu-item(index='/support-admins', :class='isMenuActive("support-admin-list")' v-if='isActiveCmp() && hasScreenAccess("support_admin_list")')
              font-awesome-icon(:icon='["fal", "users"]').el-icon-for-fa.fs-14
              span(slot='title') Support Admins

            el-menu-item(:index='getUrl()', :class='isMenuActive("support-admin-profile")' v-if='userTypeName === "Support Admin"')
              font-awesome-icon(:icon='["fa", "user"]').el-icon-for-fa.fs-14
              span(slot='title') Profile

            el-menu-item(
              v-if="userAccAccess",
              index='/manage-company/cc-account',
              :class='isMenuActive("/manage-company/cc-account")'
            )
              font-awesome-icon(:icon='["fal", "credit-card"]').el-icon-for-fa.fs-14
              span(slot='title') Add Credit Card

            el-menu-item(
              v-if='!isActiveCmp() && isCmdLockDown() && !showBulkTransactions'
              index='/cards',
              :class='isMenuActive("/cards")'
            )
              font-awesome-icon(:icon='["fal", "shopping-cart"]').el-icon-for-fa.fs-14
              span(slot='title') All Transactions

            el-submenu(
              index='/transactions'
              v-if='!isActiveCmp() && isCmdLockDown() && !showBulkTransactions'
              key='/transactions'
            )
              div(
                slot='title'
                @click='handleSelectMenu2(`/transactions`)'
                :class='isMenuActive("transactions")'
              )
                font-awesome-icon(:icon='["fal", "shopping-cart"]').el-icon-for-fa.fs-14
                //- span Transactions
                span Company Transactions
              el-menu-item(
                v-if="!showBulkTransactions"
                v-for='(teamItem, index) in this.myTeamList',
                :key='index',
                :index='`/transactions/${teamItem.id}`',
              ).d-flex.align-items-center
                font-awesome-icon(:icon='["fal", teamItem.icon]').el-icon-for-fa.fs-14
                span(slot='title').text-truncate {{ teamItem.groupName }}

            el-menu-item(
              v-if="userAccAccess && isCmdLockDown() && !showBulkTransactions",
              index='/my/transactions',
              :class='isMenuActive("/transactions/my/transactions")'
            )
              font-awesome-icon(:icon='["fal", "cash-register"]').el-icon-for-fa.fs-14
              span(slot='title') My Transactions

            // Show this only when bulk is enabled
            el-menu-item(
              v-if="showBulkTransactions"
              index='/bulk/transactions'
              :class='isMenuActive("/bulk/transactions")'
            )
              font-awesome-icon(:icon='["fal", "shopping-cart"]').el-icon-for-fa.fs-14
              span(slot='title') Bulk Transactions

            el-menu-item(
              v-if="userAccAccess",
              index='/manage-company/payment',
              :class='isMenuActive("/manage-company/payment")'
            )
              font-awesome-icon(:icon='["fal", "cash-register"]').el-icon-for-fa.fs-14
              span(slot='title') Balance & Payment

            el-submenu(index='/organization' v-if='!isActiveCmp()')
              div(slot='title')
                font-awesome-icon(:icon='["fal", "cog"]').el-icon-for-fa.fs-14
                //- span Organization
                span Settings
              el-menu-item(
                v-for='(item, index) in subMenuItems',
                v-if='showIncaseLockDonw({value1:isCmdLockDown(), value2:item})'
                :index='`/${item.slug}`',
                :key='index',
                :class='isMenuActive(item.slug)'
              )
                font-awesome-icon(:icon='["fal", item.icon]').el-icon-for-fa.fs-14
                span(slot='title') {{ item.title }}

              el-menu-item(
                  v-if="userAccAccess && isCmdLockDown()",
                  v-for='(item, index) in subMenuItems3',
                  :index='`/${item.slug}`',
                  :key='`${item.slug}`',
                  :class='isMenuActive(item.slug)'
                )
                  font-awesome-icon(:icon='["fal", item.icon]').el-icon-for-fa.fs-14
                  span(slot='title') {{ item.title }}

            el-menu-item(
              index='/accounting-integration',
              v-if='!isActiveCmp() && this.me.currentCompUserSettings && this.me.currentCompUserSettings[0].accountingSystemAccess',
              :class='isMenuActive("/accounting-integration")'
            )
              font-awesome-icon(:icon='["fal", "dollar-sign"]').el-icon-for-fa.fs-14
              span(slot='title') Accounting


            el-submenu(
              index='/'
              key='/'
            )
              div(
                slot='title'
                @click='support()'
              )
                //- faUserHeadset
                font-awesome-icon(:icon='["fal", "user-headset"]').el-icon-for-fa.fs-14
                span(icon='el-icon-service') Support
    SupportMail(
      :dialogVisible='dialogVisibleSupport'
      @handleParentClose='handleParentClose($event)'
    )

</template>

<script>
import { TimelineLite } from 'gsap';
import { mapGetters, mapActions } from 'vuex';

import SpendHubText from '@/components/logos/SpendHubText.vue';
import SpendHubLogo from '@/components/logos/SpendHubLogo.vue';
import AppSubMenuWithTeamsView from '@/components/AppSubMenuWithTeams.vue';
import SupportMail from '@/components/dialogs/supportMail.vue';

export default {
  name: 'AppMainMenu',
  components: {
    SpendHubText,
    SpendHubLogo,
    AppSubMenuWithTeamsView,
    SupportMail,
  },

  data() {
    return {
      activeMenuItem: null,
      dialogVisibleSupport: false,
      // isActiveCmp:false,
      subMenuItems: [
        {
          title: 'Add Credit Card',
          slug: 'manage-company/cc-account',
          icon: 'credit-card',
        },
        {
          title: 'Employees',
          slug: 'employees',
          icon: 'user-tie',
        },
        {
          title: 'Teams',
          slug: 'teams',
          icon: 'users',
          hasGroupPg: true,
        },
        {
          title: 'Budget Planner',
          slug: 'budget/allTeam',
          icon: 'chart-pie',
        },
        {
          title: 'Bank Connection',
          slug: 'manage-company/bank-account',
          icon: 'building',
        },
        {
          title: 'SpendHub Cards',
          slug: 'physical-cards',
          icon: 'credit-card',
        },
        {
          title: 'Credit Card Statement',
          slug: 'credit-card-statement',
          icon: 'credit-card',
        },
      ],
      subMenuItems3: [
        {
          title: 'My Companies',
          slug: 'mycompany',
          icon: 'building',
        },
      ],
      subMenuWithTeams: [
        {
          title: 'Transactions',
          slug: '/transactions',
          icon: 'shopping-cart',
        },
      ],
    };
  },

  computed: {
    ...mapGetters('shared', ['isMainMenuCollapsed']),
    ...mapGetters('groupSelected', ['groupSelectedInfo']),
    ...mapGetters('managerole', ['userTypeName']),
    ...mapGetters('users', [
      'me',
      'userCardInfo',
      'myTeamList',
      'userAccAccess',
      'userCompanyName',
      'LockDownStatus',
      'companyDetail',
    ]),
    // Show Bulk Transactions menu if company id is in the comma-separated list
    showBulkTransactions() {
      const configCompanyIds = process.env.VUE_APP_BULK_TRANSACTIONS_COMPANY_ID;
      
      // Get company ID from multiple possible sources
      let currentCompanyId = null;
      
      // Try to get from companyDetail first
      if (this.companyDetail && this.companyDetail.id) {
        currentCompanyId = this.companyDetail.id;
      } 
      // If not available, try to get from me.currentCompUserSettings
      else if (this.me && this.me.currentCompUserSettings && this.me.currentCompUserSettings[0] && this.me.currentCompUserSettings[0].companyId) {
        currentCompanyId = this.me.currentCompUserSettings[0].companyId;
      }
      // If still not available, try localStorage as fallback
      else {
        currentCompanyId = localStorage.getItem('currentCompanyId');
      }
      
      // If either value is missing, return false
      if (!configCompanyIds || !currentCompanyId) {
        console.log('Bulk Transactions: Missing config or company ID', { 
          configCompanyIds, 
          currentCompanyId,
          companyDetail: this.companyDetail,
          me: this.me ? 'available' : 'not available'
        });
        return false;
      }
      
      // Split the comma-separated list and check if current ID is in the list
      const companyIdList = configCompanyIds.split(',').map(id => id.trim());
      const isEnabled = companyIdList.includes(currentCompanyId);
      
      console.log('Bulk Transactions Check:', { 
        currentCompanyId, 
        configCompanyIds, 
        companyIdList,
        isEnabled,
        source: this.companyDetail ? 'companyDetail' : (this.me && this.me.currentCompUserSettings ? 'me.currentCompUserSettings' : 'localStorage')
      });
      
      return isEnabled;
    },
  },

  watch: {
    $route(newVal) {
      this.activeMenuItem = newVal.path;
    },
    isMainMenuCollapsed: 'initLogoAnim',
  },

  mounted() {
    this.activeMenuItem = this.$route.path;
  },
  created() {
    if (this.me) {
      this.getRoleName({ id: this.me.typeId });
    }
  },
  methods: {
    ...mapActions('managerole', ['getRoleName']),
    ...mapActions('users', ['getUsersWithTeams', 'newCompany']),
    handleParentClose() { this.dialogVisibleSupport = false; },
    showIncaseLockDonw(value) {
      if (!value.value1) {
        if (value.value2.title === 'Bank Connection') {
          return true;
        }
        return false;
      }
      return true;
    },

    support() {
      this.dialogVisibleSupport = true;
    },
    canCreateNewCompany(value) {
      if (value) {
        if (value.canCreateChildCompany) {
          return true;
        }
      }
      return false;
    },
    getPermForCCconnect(value) {
      return value && this.companyDetail.canConnectExternalCreditCard;
    },
    fnDashboard(value) {
      if (value === 'newCompany') {
        this.newCompany({ visible: true });
      }

      if (value !== 'newCompany') {
        localStorage.setItem('currentCompanyId', value.id);
        window.location.reload();
      }
    },
    initLogoAnim() {
      const { svgShTextWrap } = this.$refs;
      const timeline = new TimelineLite();

      if (this.isMainMenuCollapsed) {
        timeline.to(svgShTextWrap, 0.15, { autoAlpha: 0, display: 'none' });
      } else {
        timeline
          .set(svgShTextWrap, { autoAlpha: 0, display: 'none' })
          .to(svgShTextWrap, 0.3, { autoAlpha: 1, display: 'inline' }, 0.3);
      }
    },

    getElMenuIndex(menu) {
      if (menu.hasGroupPg && this.groupSelectedInfo.groupId) {
        return `/${menu.slug}/`;
      }
      return `/${menu.slug}`;
    },

    isMenuActive(route) {
      if (this.$route.path === route) return 'is-active';
      return '';
    },

    handleSelectMenu(key) {
      if (this.$route.path === key) return;
      this.$router.push(key);
    },
    isActiveCmp() {
      if (this.userTypeName === 'Super Admin' || this.userTypeName === 'Support Admin') {
        return true;
      }
      return false;
    },
    hasScreenAccess(screenSlug) {
      let returnFlag = true;
      if (this.userTypeName === 'Support Admin') {
        const recordIndex = this.me.supportAdminPermissions.findIndex(
          permission => permission.slug === screenSlug,
        );
        if (recordIndex < 0) {
          returnFlag = false;
        }
      }
      return returnFlag;
    },
    handleSelectMenu2(value) {
      // available perms: key, keyPath
      this.$router.push(value);
    },

    isCmdLockDown() {
      return !(this.LockDownStatus);
    },
    getUrl() {
      return `/support-admins/${this.me.id}/edit`;
    },
  },
};
</script>
